import { ReactNode, useEffect, useRef, useState } from "react";
import { mdiArrowLeft, mdiArrowRight, mdiBank, mdiEmail, mdiHelpCircleOutline, mdiMapMarker, mdiMenu, mdiPhone } from "@mdi/js";
import Icon from "@mdi/react";
import { Link } from "easy-page-router/react";
import { useUser } from "./User";

export default function Layout({ children }: { children: ReactNode }) {
    const { user, isAdmin, isEditor, setUser } = useUser();

    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const [showMenu, setShowMenu] = useState(false);
    const refMenu = useRef<HTMLAnchorElement | null>(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!refMenu.current || refMenu.current.contains(event.target)) {
                return;
            }
            setShowMenu(false);
        }
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return <>
        <nav className={isScrolled ? "scrolled" : ""}>
            <Link href="/" className="logo" > </Link>
            <a ref={refMenu} className="menu-mobile" onClick={() => setShowMenu(true)}><Icon path={mdiMenu} size={1.7} /></a>
            <div className={`menu ${showMenu ? "show" : ""}`}>
                <Link href="/">Úvod</Link>
                <Link href="/akce">Akce</Link>
                <Link href="/o-nas">O nás</Link>
                <Link href="/projekty">Projekty</Link>
                <Link href="/oddily-a-spolky">Oddíly a Spolky</Link>
                <Link href="/fotogalerie">Fotogalerie</Link>
                <Link href="/dokumenty">Dokumenty</Link>
                <Link href="/ubytovani">Ubytování</Link>
                <Link href="/kontakt">Kontakt</Link>
                <Link className="button" href="/admin">
                    {!user ? "Přihlášení" : isAdmin ? "Admin" : isEditor ? "Editor" : user.name}
                    <Icon path={mdiArrowRight} size={0.9} />
                </Link>
            </div>
        </nav>
        <main>
            {children}
        </main>
        <footer>
            <div className="column width-max">
                <div>
                    <div className="logo" />
                    <p>Výkladní skříní ponikelského Sokola je v dnešní době zejména kondiční cvičení a cvičení
                        s pompony. Ponikelští Sokolové pečují o Sokolský areál Na Vršku, kde provozují rekreační
                        chatu Babetu a venkovní hřiště. Sokol dnes sdružuje pod svými křídly i další autonomní
                        spolky, čímž naplňuje základní Sokolské heslo o tříbení těla i ducha.</p>
                </div>
                <div className="contact-info">
                    <h4>Kontakt</h4>
                    <div>
                        <Icon path={mdiMapMarker} size={1} />
                        Tělocvičná jednota Sokol Poniklá<br />
                        Poniklá 65, 512 42
                    </div>
                    <div>
                        <Icon path={mdiHelpCircleOutline} size={1} />
                        IČ: 49295276
                    </div>
                    <div>
                        <Icon path={mdiBank} size={1} />
                        Moneta Money Bank a. s.<br />
                        č. ú.: 223726423/0600
                    </div>
                    <div>
                        <Icon path={mdiEmail} size={1} />
                        info@sokolponikla.cz
                    </div>
                </div>
                <div className="links">
                    <h4>Rychlé odkazy</h4>
                    <Link href="/o-nas">O nás</Link>
                    <Link href="/projekty">Projekty</Link>
                    <Link href="/dokumenty">Dokumenty</Link>
                    <Link href="/ubytovani">Ubytování</Link>
                    <Link href="/kontakt">Kontakt</Link>
                </div>
            </div>
            <div className="copyright">
                <div className="width-max">
                    © Copyright 2025 <Link className="sokol" href="/">SOKOL Poniklá</Link>
                    <div className="grow-1" />
                    <a href="https://paulu.cz/" target="_blank">Vytvořil - Filip</a>
                    <div className="divider" />
                    <a href="https://www.graphto.art/" target="_blank">Design - Graphto.art</a>
                </div>
            </div>
        </footer>
    </>;
}